module.exports = __WEBPACK_EXTERNAL_MODULE_275__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display3D/textures/RectangleTexture","root":["openfl","display3D","textures","RectangleTexture"],"commonjs":"openfl/display3D/textures/RectangleTexture","commonjs2":"openfl/display3D/textures/RectangleTexture"}
// module id = 275
// module chunks = 0